import { take } from "./util";
export const fromGql = (error) => take(error, 'path', 'message');
export const fromGqlCollection = (errors = []) => (errors === null || errors === void 0 ? void 0 : errors.map(fromGql)) || [];
//# sourceMappingURL=VPError.js.map